import { useState } from 'react';
import { FallbackDiv, FallbackSvg, StyledImg } from './styled';
import { getCompanyLogoBackground } from './utils';
import { shallowEqual, useSelector } from 'react-redux';
import type { State as CompanyState } from '@/pages/CompanyReport/redux/interface';
interface State {
  company: CompanyState;
}
interface Selected {
  imgSrc: string;
  tickerSymbol: string;
}
interface CompanyIconProps {
  companyId: string;
}

const CompanyIcon = ({ companyId }: CompanyIconProps) => {
  const { imgSrc, tickerSymbol } = useSelector<State, Selected>((state) => {
    const summary = state.company.summary[companyId];
    const website = summary?.website || '';
    const tickerSymbol = summary?.tickerSymbol
      ? String(summary.tickerSymbol)
      : '';
    let imgSrc = '';
    try {
      const host = new URL(website).host;
      imgSrc = `https://logo.clearbit.com/${host}?size=128`;
      //URL constructor may fail if invalid website
    } catch (error) {}

    return { imgSrc, tickerSymbol };
  }, shallowEqual);

  const [showFallback, setShowFallback] = useState<boolean>(false);
  const onImageError = () => {
    setShowFallback(true);
  };

  if (!imgSrc) {
    return <FallbackDiv />;
  }

  if (showFallback) {
    return (
      <FallbackSvg
        xmlns="http://www.w3.org/2000/svg"
        width="64px"
        height="64px"
        viewBox="0 0 64 64"
      >
        <rect
          fill={`#${getCompanyLogoBackground(tickerSymbol)}`}
          cx="32"
          width="64"
          height="64"
          cy="32"
          r="32"
        />
        <text
          x="50%"
          y="50%"
          alignmentBaseline="middle"
          textAnchor="middle"
          fontSize="21"
          fontWeight="400"
          dy=".1em"
          dominantBaseline="middle"
          fill="#ffffff"
        >
          {tickerSymbol.substring(0, 4)}
        </text>
      </FallbackSvg>
    );
  }

  return <StyledImg src={imgSrc} onError={onImageError} alt={tickerSymbol} />;
};

export default CompanyIcon;
